import React from 'react';
import { observer } from 'mobx-react';
import OpenChats from './open-chats/OpenChats';
import FansList from './fans-list/FansList';
import Search from './search/Search';
import MassMessage from './mass-message/MassMessage';

import { RootStoreContext } from '../../../../context';

import './Sidebar.css';
import '../../../../css/utils/flex.css';

@observer
class Sidebar extends React.Component {

  static contextType = RootStoreContext;

  render () {
    const {
      privateMessagingStore: {
        tabsToRender,
        displaySidebar,
      },
      loggedInUser
    } = this.context;
    return (
      <aside
        id="private-chat-sidebar"
        className="flex flex-col"
        style={!displaySidebar ? { display: 'none' } : null}>
        {loggedInUser.account.anchor && <Search />}
        <div className="tabs flex">
          {tabsToRender.tabs.map(tab => {
            let className = 'tab';
            if (tab.tab === tabsToRender.active) {
              className += ' tab--active'
            }
            if (!loggedInUser.account.anchor) {
              className += ' tab--member'
            }
            return (
              <div
                key={tab.tab}
                className={className}
                onClick={() => this.context.privateMessagingStore.changeActiveTab(tab)}>
                {tab.label}
              </div>
            )}
          )}
        </div>
        <div className="tab-container">
          {tabsToRender.active === 'open-chats' && <OpenChats />}
          {tabsToRender.active === 'fans-list' && <FansList />}
          {tabsToRender.active === 'mass-messages' && <MassMessage />}
        </div>
      </aside>
    );
  }
}

export default Sidebar;